// extracted by mini-css-extract-plugin
module.exports = {"Default":"SVGImage_Default__3Q-9N","Primary":"SVGImage_Primary__3lGCC","Secondary":"SVGImage_Secondary__2QT9f","Disabled":"SVGImage_Disabled__26BSC"};